import * as React from 'react'

import { Box } from '@factorialco/deprecated-design-system'
import classNames from 'classnames/bind'
import type { Field } from 'factorial-form'

import { observer } from 'mobx-react'

import Toggler from 'modules/core/components/Toggler'

import styles from './index.module.css'

const cx = classNames.bind(styles)
interface Props {
  field: Field
  label?: string
  disabled?: boolean
  onChange?: (newValue: boolean) => void
  fullWidth?: boolean
}

function TogglerCheckbox({ field, label, onChange, fullWidth = true, disabled = false }: Props) {
  const _onChange = () => {
    if (disabled) return

    const newValue = !field.value
    field.set(newValue)

    if (onChange) onChange(newValue)
  }

  return (
    <div
      className={cx('root', {
        fullWidth,
      })}
      onClick={_onChange}
    >
      {!!label && <span className={styles.text}>{label}</span>}
      <Toggler disabled={disabled} active={!!field.value} />
    </div>
  )
}

interface ContainerProps {
  children: JSX.Element[]
}

const Container = ({ children }: ContainerProps) => {
  return (
    <Box
      gap="s8"
      padding="s16"
      background="grey000White"
      textAlign="left"
      borderRadius={{
        all: 'abs008',
      }}
      border={{
        all: {
          width: 's1',
          color: 'grey400',
          style: 'solid',
        },
      }}
    >
      {children}
    </Box>
  )
}

interface ExpandableContainerProps {
  open: boolean
  children: JSX.Element[]
  overflowX?: 'hidden' | 'visible'
  overflowY?: 'hidden' | 'visible'
}

const ExpandableContainer = ({
  open,
  children,
  overflowX = 'hidden',
  overflowY = 'hidden',
}: ExpandableContainerProps) => {
  const [header, content] = children

  return (
    <Box
      background="grey200"
      border={{
        all: {
          width: 's1',
          style: 'solid',
          color: 'grey400',
        },
      }}
      borderRadius={{
        all: 'abs008',
      }}
      overflowX={overflowX}
      overflowY={overflowY}
    >
      <Box
        background="grey000White"
        padding="s24"
        border={
          open
            ? {
                bottom: {
                  width: 's1',
                  style: 'solid',
                  color: 'grey400',
                },
              }
            : {}
        }
      >
        {header}
      </Box>
      {open && content}
    </Box>
  )
}

TogglerCheckbox.Container = Container
TogglerCheckbox.ExpandableContainer = ExpandableContainer

export default observer(TogglerCheckbox)
